import { getContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';

export const useShowMachineTranslationButton = () => {
    const { locale } = getContext();

    const isDefaultLocale = locale === DEFAULT_FIVERR_LOCALE;

    return !isDefaultLocale;
};
